import { matchesWords, type ResultOf } from '@horof/shared';
import { graphql } from '../gql';

export const CommitteeMembersDocument = graphql(`
  query CommitteeMembers {
    members(orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC]) {
      nodes {
        id
        fullName
        memberAddress
        phoneStatus
        notifyChannel
        notifyPhone
        contactName
        meters {
          nodes {
            label
          }
        }
        unnamedShart: shartPeople(
          filter: { name: { equalTo: "شخص غير مسمى" } }
        ) {
          totalCount
        }
      }
    }
  }
`);

export const MemberDetailsDocument = graphql(`
  query MemberDetails($id: UUID!) {
    member(id: $id) {
      id
      fullName
      firstName
      fatherName
      lastName
      sex
      memberAddress
      phone
      contactPhone
      contactName
      notifyChannel
      notifyPhone
      phoneStatus
      email
      committeeRole
      joinedAt
      statementLink
      noticeLink
      meters(orderBy: [SORT_ORDER_ASC]) {
        nodes {
          id
          label
          meterNo
          meterAddress
          meterStatus
        }
      }
      unpaid: bills(filter: { billStatus: { notEqualTo: PAID } }) {
        totalCount
      }
      shartPeople(orderBy: [CREATED_AT_ASC]) {
        nodes {
          id
          name
          createdAt
        }
      }
    }
    currentSettings {
      associationName
    }
  }
`);

type MemberNode = NonNullable<
  NonNullable<
    ResultOf<typeof CommitteeMembersDocument>['members']
  >['nodes'][number]
>;

export const matchesMember = (m: MemberNode, query: string) =>
  matchesWords(
    [
      m.fullName,
      m.memberAddress,
      m.notifyPhone,
      ...m.meters.nodes.map((meter) => meter?.label),
    ],
    query,
  );
